import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import GeneralView from '../../components/pages/creamShop/generalView';
import BuyView from '../../components/pages/creamShop/buyView';
import SellView from '../../components/pages/creamShop/sellView';
import CreamShopTransactions from '../../components/pages/creamShop/transactions';

enum Views {
  GENERAL,
  BUY,
  SELL
}

const CreamShopPage = () => {
  const urlParams = useParams();

  const selectedView = useMemo<Views>(() => {
    switch (urlParams?.view) {
      case 'buy':
        return Views.BUY;
      case 'sell':
        return Views.SELL;
      default:
        return Views.GENERAL;
    }
  }, [urlParams?.view]);

  return (
    <>
      <InnerContent view={selectedView} />
      <CreamShopTransactions />
    </>
  );
};

interface InnerContentParams {
  view: Views;
}

const InnerContent = ({ view }: InnerContentParams) => {
  switch (view) {
    case Views.GENERAL:
      return <GeneralView />;
    case Views.BUY:
      return <BuyView />;
    case Views.SELL:
      return <SellView />;
    default:
      return null;
  }
};

export default CreamShopPage;
